<button fastTooltip="Browser is not supported" (click)="toggle()" cdkOverlayOrigin #trigger="cdkOverlayOrigin" semerisIconButton  color="warn">
  <mat-icon>warning</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayPanelClass]="['semeris-overlay', 'not-supported-browser-overlay']"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'overlay-transparent'"
  (backdropClick)="toggle()"
>
  <div class="semeris-overlay-container mat-elevation-z4 not-supported-browser-overlay-container">
    <div class="placeholder-container not-supported-container">
      <div class="placeholder-message">
        <i class="material-icons">browser_not_supported</i>
        <h3>Browser is not supported</h3>
        <h4><b>We recommend using a newer browser with Semeris Docs</b></h4>
        <h4>
          Semeris Docs uses modern web technologies to deliver the best possible user experience. Based on the version of your internet
          browser, we believe <b>some functions might not work.</b>
        </h4>
        <h4>
          Supported browsers include <b>any recent version</b> of <b>Chrome, Edge, Firefox</b> or <b>Safari</b>, in each case desktop,
          tablet and mobile versions. <b>Internet Explorer</b> is <b>not supported</b>.
        </h4>
        <h4>
          Certain functions require larger screens (e.g. like deal and market comparisons), those are not supported on mobile platforms.
        </h4>
        <h5>
          Intersection observer is <b>{{ intersectionObserverSupported ? 'supported' : 'not supported' }}</b> by your browser.<br />
          URL constructor is <b>{{ urlConstructorSupported ? 'supported' : 'not supported' }}</b> by your browser.<br />
          {{ browserInfo }}
        </h5>
      </div>
    </div>
  </div>
</ng-template>
